module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_8_D_2.e49e0699.mp3";